export const notAvailable = 'n/a';
